import { CreateExperienceCustomMetricFe } from "@intelligems/ig-types";
import { AnalyticsActiveFilterType } from "@src/store/types/dashboardFilters";

export const getFilterLabel = (
  filter: AnalyticsActiveFilterType,
  customMetrics: CreateExperienceCustomMetricFe[]
) => {
  if (filter.key === "customEvents") {
    if (filter.value.length > 2) {
      let label = "";
      label = filter.value
        .slice(0, 2)
        .map(
          (value) =>
            customMetrics.find(
              (metric) => metric.customEvent.identifier === value
            )?.customEvent.name
        )
        .filter(Boolean)
        .join(", ");
      label = label + `, ... + ${filter.value - 2} more`;
      return `Custom Events: ${label}`;
    } else {
      let label = "";
      label = filter.value
        .map(
          (value) =>
            customMetrics.find(
              (metric) => metric.customEvent.identifier === value
            )?.customEvent.name
        )
        .filter(Boolean)
        .join(", ");
      return `Custom Events: ${label}`;
    }
  }
  return filter.label;
};
